module.exports = __webpack_public_path__ + "static/media/SolarWaterHeater2.5822e8e3.jpg";